<banner-app [Fixtop]="''" [retroSelected]="true" [infoDueno]="true" [showPromo]="true"></banner-app>

<div class="container">
  <div class="row sura-main-container__container-row">
    <div
      class="col-12 col-sm-6 text-primary-emphasis fw-bolder text-center mb-3 lh-1 sura-main-container__hero-title d-flex flex-column">
      <div class="order-1 order-sm-0">
        <h3>Tu pago ha sido aprobado</h3>
        Te enviaremos un correo con la confirmación y los detalles de tu seguro
      </div>
      <div class="order-0 order-sm-1">
        <img src="./assets/img/PantallaFin_PagoAprobado.png" width="540" height="320" loading="lazy"
          alt="seguro de moto precio" />
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <h4 class="sura__heading underlined">Información de pago</h4>
      <div class="sura-lists sura__mb-big">
        <dl>
          <dt>Estado</dt>
          <dd>Aprobado</dd>
          <dt>Valor</dt>
          <dd>${{ ((planes.data.plan.paymentFrecuency === 'Monthly' ? planes?.data?.plan?.price?.price_monthly?.amount :
            planes.data.plan.price.full.amount) ?? 0) | customNumberFormat }}</dd>
          <dt>Código respuesta</dt>
          <dd>00</dd>
          <dt>Referencia de pago</dt>
          <dd>{{ planes.data.pre_policy_number }}</dd>
          <dt>Forma de pago</dt>
          <dd>
            {{ planes.data.plan.paymentFrecuency === 'Annually' ? 'Anual' :
            planes.data.plan.paymentFrecuency === 'Monthly' ? 'Mensual' :
            planes.data.plan.paymentFrecuency }}
          </dd>

        </dl>
      </div>


      <h4 class="sura__heading underlined">Resumen de compra</h4>
      <div class="card sura-card shadow">
        <div class="card-header bg-primary text-white px-4 pt-4 pb-3">
          <h3 class="fw-semibold">{{ this.planes.data.plan.selected }}</h3>
          Moto: {{this.datosGenerales?.LeadResponse?.data?.vehicle?.brand + ' ' +
          this.datosGenerales?.LeadResponse?.data?.vehicle?.model + ' ' +
          this.datosGenerales?.LeadResponse?.data?.vehicle?.cylinder }} CC
        </div>
        <div class="card-body container-fluid">
          <div class="row text-primary-emphasis px-2 fw-semibold">
            <div class="col-12">Dueño</div>
            <div class="col-6">
              {{ planes.data.asset.owner.fullname }}
            </div>
            <div class="col-6 text-end">
              <ng-container [ngSwitch]="planes.data.asset.owner.document.type">
                <span *ngSwitchCase="'C'">C.C.</span>
                <ng-container *ngSwitchCase="'E'">C.E.</ng-container>
                <ng-container *ngSwitchCase="'P'">P.</ng-container>
                <ng-container *ngSwitchDefault>{{ planes.data.asset.owner.document.type }}</ng-container>
              </ng-container>
              {{ planes.data.asset.owner.document.number }}
            </div>
            <div class="col-12">{{ planes.data.plan.zonaCirculacion }}</div>
          </div>

          <hr class="sura-hr">

          <div class="row px-2">
            <div class="col-12">

              <div class="sura__price-tag fullwidth">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13" cy="13" r="13" fill="white" />
                  <path
                    d="M12.5723 16.5375V17.5481H13.5829V16.5375H13.9568C15.0735 16.5375 15.978 15.633 15.978 14.5163C15.978 13.3997 15.0735 12.4952 13.9568 12.4952H12.1984C11.6426 12.4952 11.1878 12.0404 11.1878 11.4846C11.1878 10.9288 11.6426 10.474 12.1984 10.474H14.4115C14.9674 10.474 15.4221 10.0193 15.4221 9.46346H13.5829V8.45288H12.5723V9.46346H12.1984C11.0817 9.46346 10.1772 10.3679 10.1772 11.4846C10.1772 12.6013 11.0817 13.5058 12.1934 13.5058H13.9568C14.5126 13.5058 14.9674 13.9605 14.9674 14.5163C14.9674 15.0722 14.5126 15.5269 13.9568 15.5269H11.1727C10.6169 15.5269 10.1621 15.9817 10.1621 16.5375H12.5673H12.5723Z"
                    fill="#2D6DF6" />
                  <path
                    d="M7.00405 6.92681C8.62602 5.30484 10.7836 4.41048 13.0776 4.41048C17.8122 4.41048 21.6675 8.26583 21.6675 13.0004H22.6781C22.6781 7.70496 18.373 3.3999 13.0776 3.3999C10.5158 3.3999 8.10051 4.40037 6.29158 6.2093L5.5791 6.92176C5.97323 7.31589 6.61498 7.31589 7.00911 6.92176L7.00405 6.92681Z"
                    fill="#2D6DF6" />
                  <path
                    d="M23.9562 12.5811L22.1675 14.3698L20.3787 12.5811L19.6663 13.2935L21.8087 15.4359C21.9097 15.537 22.0361 15.5825 22.1675 15.5825C22.2988 15.5825 22.4251 15.5319 22.5262 15.4359L24.6686 13.2935L23.9562 12.5811Z"
                    fill="#2D6DF6" />
                  <path
                    d="M19.1408 19.0792C17.5189 20.7012 15.3613 21.5955 13.0673 21.5955C8.33272 21.5955 4.47737 17.7402 4.47737 13.0056H3.4668C3.4668 18.301 7.77185 22.6061 13.0673 22.6061C15.6291 22.6061 18.0443 21.6056 19.8583 19.7967L20.5708 19.0842C20.1767 18.6901 19.535 18.6901 19.1408 19.0842V19.0792Z"
                    fill="#2D6DF6" />
                  <path
                    d="M5.76066 13.4248L6.47314 12.7123L4.33072 10.5699C4.13366 10.3729 3.81531 10.3729 3.61825 10.5699L1.47583 12.7123L2.1883 13.4248L3.97704 11.6361L5.76572 13.4248H5.76066Z"
                    fill="#2D6DF6" />
                </svg>
                Valor asegurado <span>${{ (planes.data.plan.sumInsured?.amount ?? 0) | customNumberFormat }}</span>
              </div>

            </div>
          </div>


          <hr class="sura-hr">

          <div class="row px-2">
            <div class="col-12">
              <div class="sura-lists included featured alter">
                <h4>Coberturas:</h4>
                <ul *ngIf="planes?.data?.plan?.coveragesGroup?.length">
                  <ng-container *ngFor="let cobertura of planes.data.plan.coveragesGroup; let i = index">
                    <div *ngIf="cobertura.include">
                      <li>
                        <b>{{ cobertura.name }} </b>
                      </li>
                    </div>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>

          <hr class="sura-hr">

          <div class="row">
            <div class="col-12">Tu póliza de seguro inicia el</div>
            <div class="col-12 fs-5 text-primary-emphasis fw-semibold">{{ planes.data.plan.effectiveDate }}</div>
          </div>

          <!--          <hr class="sura-hr">-->

          <!--          <div class="row fw-semibold">-->
          <!--            <div class="col-8">Forma de pago</div>-->
          <!--            <div class="col-4 text-end">Anual</div>-->

          <!--            <div class="col-8">Subtotal</div>-->
          <!--            <div class="col-4 text-end">$901.224</div>-->

          <!--            <div class="col-8">Ahorro pago anaual -20%</div>-->
          <!--            <div class="col-4 text-end">$180.000</div>-->
          <!--          </div>-->

          <!-- <hr class="sura-hr"> -->

          <!-- <div class="row text-primary fs-5 fw-semibold">
            <div class="col-8">Pago Total</div>
            <div class="col-4 text-end">{{ planes.data.plan.. }}</div>
          </div> -->


        </div>
      </div>

      <a class="sura-btn" (click)="entendido()">Entendido</a>

    </div>
  </div>
</div>

<app-footer-app class="footer-fixed" />